import { iToolTips, iCountry } from '@interfaces/interfaces';
import { getCountryListMock, getToolTipsMock } from './ReferenceDataMock';

const { REACT_APP_SITECORE_API_ENDPOINT: API_URL, NODE_ENV, REACT_APP_SITECORE_API_MOCK } = process.env;

export const getCountryList = async (): Promise<iCountry[]> => {
  if (NODE_ENV === 'development' || REACT_APP_SITECORE_API_MOCK === 'true') {
    return getCountryListMock();
  }

  const urlCountryList = `${API_URL}sitecore/Globalization/GetCountryList`;
  const results = await fetch(urlCountryList);
  const json: iCountry[] = await results.json();
  return json;
};

interface iTooltipResults {
  Locator: string;
  Body: string;
}

const mapToolTips = (tooptips: iTooltipResults[]): iToolTips => {
  const mappedTooltips = {} as iToolTips;
  tooptips.forEach((tooltip: iTooltipResults, _index: any) => {
    let keyName = tooltip.Locator;
    // accordion content are managed in Sitecord, it contains step0, order is step01, step02 ...
    if ((tooltip.Locator.includes('step0')) || (tooltip.Locator.includes('obligationlocationonformstep1modal'))) {
      keyName = tooltip.Locator.replace('-', '|');
    } else {
      keyName = tooltip.Locator.replaceAll('-', '');
    }
    mappedTooltips[keyName] = tooltip.Body;
  });
  return mappedTooltips;
};

export const getTooltips = async (formNameValue = 'fines.ReviewForm'): Promise<iToolTips> => {
  if (NODE_ENV === 'development' && REACT_APP_SITECORE_API_MOCK === 'true') {
    return getToolTipsMock();
  }
  const payload = {
    formName: formNameValue
  };
  const header = {
    'Content-Type': 'application/json',
  };
  const urlTootips = `${API_URL}sitecore/Tooltip/GetTooltips`;
  const results = await fetch(urlTootips, {
    method: 'POST',
    headers: header,
    body: JSON.stringify(payload),
  });
  const json: iTooltipResults[] = await results.json();
  return mapToolTips(json);
};
